import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
    api_url = `${protocol}//${hostname}/api`
}

const getLanguagesRequested = () => ({
    type: types.GET_LANGUAGES_REQUESTED,
    payload: null
})

const getLanguagesFulfilled = (data) => ({
    type: types.GET_LANGUAGES_FULFILLED,
    payload: data
})

const getLanguagesRejected = (error) => ({
    type: types.GET_LANGUAGES_REJECTED,
    payload: error
})

export const getLanguages = (token: string) => {
    return (dispatch: any) => {
        dispatch(getLanguagesRequested())
        request
            .get(`${api_url}/language`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getLanguagesFulfilled(response.body))
            })
            .catch((error) => {
                dispatch(getLanguagesRejected(error))
            })
    }
}